import React, { useState } from 'react';
import './ArticleForm.css';

function ArticleForm({ onAddArticle }) {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [content, setContent] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!title.trim() || !author.trim() || !content.trim()) {
      alert('Please fill in all fields');
      return;
    }

    onAddArticle({
      title: title.trim(),
      author: author.trim(),
      content: content.trim(),
    });

    // Clear form
    setTitle('');
    setAuthor('');
    setContent('');
  };

  return (
    <div className="article-form">
      <h2>✍️ Create New Article</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">标题/Title</label>
          <input
            type="text"
            id="title"
            placeholder="Enter article title..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="author">作者/Author</label>
          <input
            type="text"
            id="author"
            placeholder="Enter author name..."
            defaultValue="WebMaster" 
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">内容/Content</label>
          <textarea
            id="content"
            placeholder="Write your article content..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows={10}
          />
        </div>

        <button type="submit" className="submit-btn">
          📤 Publish Article
        </button>
      </form>
    </div>
  );
}

export default ArticleForm;
